import createClient from 'openapi-fetch';

import { stepinMiddleware } from '@/@shared/middleware/middleware';

import type { components, paths } from '@/legacy/apis/spec/contentType';

const instanceGetter = () => {
	const stepinContentInstance = createClient<paths>({
		baseUrl: process.env.NEXT_PUBLIC_STEPIN_CONTENT,
	});
	stepinContentInstance.use(stepinMiddleware);
	return stepinContentInstance;
};

export const stepinContentInstance = instanceGetter();

//@ts-ignore
export type PathType<PATH extends keyof paths, METHOD> = NonNullable<paths[PATH][METHOD]['responses']>;

export type SimpleDance = components['schemas']['SimpleDance'];
export type TournamentInquiryData = components['schemas']['TournamentInquiryData'];
export type TournamentInfo = components['schemas']['TournamentInfo'];
export type TournamentDetailResponseDto = components['schemas']['TournamentDetailResponseDto'];

export type DanceBoxDance = components['schemas']['DanceBoxDance'];
export type DanceBoxInfo_DanceBox = components['schemas']['DanceBoxInfo_DanceBox'];
export type User = components['schemas']['User'];
export type Box = components['schemas']['Box'];
export type Comment = components['schemas']['Comment'];
export type Artist = components['schemas']['Artist'];
export type Music = components['schemas']['Music'];
export type Dance = components['schemas']['Dance'];
export type Video = components['schemas']['Video'];
// export type Version = components['schemas']['Version'];
export type Hashtag = components['schemas']['Hashtag'];
// export type Maintenance = components['schemas']['Maintenance'];
// export type Notice = components['schemas']['Notice'];
// export type Event = components['schemas']['Event'];
export type CustomDataLocalization = components['schemas']['CustomDataLocalization'];
export type CustomData = components['schemas']['CustomData'];
export type Inbox = components['schemas']['Inbox'];
export type virtual = components['schemas']['virtual'];
// export type PlatformVersion_Version = components['schemas']['PlatformVersion_Version'];
// export type PlatformVersion = components['schemas']['PlatformVersion'];
// export type GetPlatformVersionRO = components['schemas']['GetPlatformVersionRO'];
// export type GetPlatformVersionResponse = components['schemas']['GetPlatformVersionResponse'];
// export type ServiceMaintenance_Maintenance = components['schemas']['ServiceMaintenance_Maintenance'];
// export type ServiceMaintenance = components['schemas']['ServiceMaintenance'];
// export type GetServiceMaintenanceRO = components['schemas']['GetServiceMaintenanceRO'];
// export type GetServiceMaintenanceResposne = components['schemas']['GetServiceMaintenanceResposne'];
// export type ConfirmEventRO = components['schemas']['ConfirmEventRO'];
// export type ConfirmEventResponse = components['schemas']['ConfirmEventResponse'];
// export type CommonEvent_Event = components['schemas']['CommonEvent_Event'];
// export type CommonEvent = components['schemas']['CommonEvent'];
// export type GetEventListRO = components['schemas']['GetEventListRO'];
// export type GetEventListResponse = components['schemas']['GetEventListResponse'];
// export type EventBanner_Event = components['schemas']['EventBanner_Event'];
// export type EventBanner = components['schemas']['EventBanner'];
// export type GetEventBannerListRO = components['schemas']['GetEventBannerListRO'];
// export type GetEventBannerListResponse = components['schemas']['GetEventBannerListResponse'];
// export type EventPopup_Event = components['schemas']['EventPopup_Event'];
// export type EventPopup = components['schemas']['EventPopup'];
// export type GetEventPopupListRO = components['schemas']['GetEventPopupListRO'];
// export type GetEventPopupListResponse = components['schemas']['GetEventPopupListResponse'];
// export type ShopBanner_Event = components['schemas']['ShopBanner_Event'];
// export type ShopBanner = components['schemas']['ShopBanner'];
// export type GetShopBannerRO = components['schemas']['GetShopBannerRO'];
// export type GetShopBannerResponse = components['schemas']['GetShopBannerResponse'];
// export type ConfirmNoticeRO = components['schemas']['ConfirmNoticeRO'];
// export type ConfirmNoticeResponse = components['schemas']['ConfirmNoticeResponse'];
// export type CommonNotice_Notice = components['schemas']['CommonNotice_Notice'];
// export type CommonNotice = components['schemas']['CommonNotice'];
// export type GetNoticeListRO = components['schemas']['GetNoticeListRO'];
// export type GetNoticeListResponse = components['schemas']['GetNoticeListResponse'];
export type CheckNewInboxRO = components['schemas']['CheckNewInboxRO'];
export type CheckNewInboxResponse = components['schemas']['CheckNewInboxResponse'];
export type ActivityInbox_Inbox = components['schemas']['ActivityInbox_Inbox'];
export type ActivityInbox_User = components['schemas']['ActivityInbox_User'];
export type ActivityInbox_Opponent = components['schemas']['ActivityInbox_Opponent'];
export type ActivityInbox = components['schemas']['ActivityInbox'];
export type GetActivityInboxListRO = components['schemas']['GetActivityInboxListRO'];
export type GetActivityInboxListResponse = components['schemas']['GetActivityInboxListResponse'];
export type CreateInviteInboxBody = components['schemas']['CreateInviteInboxBody'];
export type CheckNewStorageRO = components['schemas']['CheckNewStorageRO'];
export type CheckNewStorageResponse = components['schemas']['CheckNewStorageResponse'];
export type Reward = components['schemas']['Reward'];
export type StorageCustomData = components['schemas']['StorageCustomData'];
export type CommonStorage_Storage = components['schemas']['CommonStorage_Storage'];
export type CommonStorage = components['schemas']['CommonStorage'];
export type GetStorageListRO = components['schemas']['GetStorageListRO'];
export type GetStorageListResponse = components['schemas']['GetStorageListResponse'];
export type AcquireStorageRO = components['schemas']['AcquireStorageRO'];
export type AcquireStorageResponse = components['schemas']['AcquireStorageResponse'];
export type CreateStorageBody = components['schemas']['CreateStorageBody'];
export type AcquireAllStorageRO = components['schemas']['AcquireAllStorageRO'];
export type AcquireAllStorageResponse = components['schemas']['AcquireAllStorageResponse'];
export type RefundBody = components['schemas']['RefundBody'];
export type ArtistInfo_Artist = components['schemas']['ArtistInfo_Artist'];
export type ArtistInfo = components['schemas']['ArtistInfo'];
export type GetArtistInfoRO = components['schemas']['GetArtistInfoRO'];
export type GetArtistInfoResponse = components['schemas']['GetArtistInfoResponse'];
export type BoostArtistBody = components['schemas']['BoostArtistBody'];
export type DanceInfo_Dance = components['schemas']['DanceInfo_Dance'];
export type DanceInfo_Artist = components['schemas']['DanceInfo_Artist'];
export type DanceInfo = components['schemas']['DanceInfo'];
export type GetDanceInfoRO = components['schemas']['GetDanceInfoRO'];
export type GetDanceInfoResponse = components['schemas']['GetDanceInfoResponse'];
export type BookmarkDanceBody = components['schemas']['BookmarkDanceBody'];
export type BookmarkDanceRO = components['schemas']['BookmarkDanceRO'];
export type BookmarkDanceResponse = components['schemas']['BookmarkDanceResponse'];
export type NewDance_Dance = components['schemas']['NewDance_Dance'];
export type NewDance_Artist = components['schemas']['NewDance_Artist'];
export type NewDance = components['schemas']['NewDance'];
export type GetNewDanceListRO = components['schemas']['GetNewDanceListRO'];
export type GetNewDanceListResponse = components['schemas']['GetNewDanceListResponse'];
export type AllDance_Dance = components['schemas']['AllDance_Dance'];
export type AllDance_Artist = components['schemas']['AllDance_Artist'];
export type AllDance = components['schemas']['AllDance'];
export type GetAllDanceListRO = components['schemas']['GetAllDanceListRO'];
export type GetAllDanceListResponse = components['schemas']['GetAllDanceListResponse'];
export type TodayPracticeDance_Dance = components['schemas']['TodayPracticeDance_Dance'];
export type TodayPracticeDance_Artist = components['schemas']['TodayPracticeDance_Artist'];
export type TodayPracticeDance = components['schemas']['TodayPracticeDance'];
export type GetTodayPracticeDanceListRO = components['schemas']['GetTodayPracticeDanceListRO'];
export type GetTodayPracticeDanceListResponse = components['schemas']['GetTodayPracticeDanceListResponse'];
export type BookmarkedDance_Dance = components['schemas']['BookmarkedDance_Dance'];
export type BookmarkedDance_Artist = components['schemas']['BookmarkedDance_Artist'];
export type BookmarkedDance = components['schemas']['BookmarkedDance'];
export type GetBookmarkedDanceListRO = components['schemas']['GetBookmarkedDanceListRO'];
export type GetBookmarkedDanceListResponse = components['schemas']['GetBookmarkedDanceListResponse'];
export type ArtistDance_Dance = components['schemas']['ArtistDance_Dance'];
export type ArtistDance_Artist = components['schemas']['ArtistDance_Artist'];
export type ArtistDance = components['schemas']['ArtistDance'];
export type GetArtistDanceListRO = components['schemas']['GetArtistDanceListRO'];
export type GetArtistDanceListResponse = components['schemas']['GetArtistDanceListResponse'];
export type RecommendRotationDanec_Dance = components['schemas']['RecommendRotationDanec_Dance'];
export type RecommendRotationDance_Artist = components['schemas']['RecommendRotationDance_Artist'];
export type RecommendRotationDance = components['schemas']['RecommendRotationDance'];
export type GetRecommendRotationListRO = components['schemas']['GetRecommendRotationListRO'];
export type GetRecommendRotationListResponse = components['schemas']['GetRecommendRotationListResponse'];
export type BoyGroupRotationDanec_Dance = components['schemas']['BoyGroupRotationDanec_Dance'];
export type BoyGroupRotationDance_Artist = components['schemas']['BoyGroupRotationDance_Artist'];
export type BoyGroupRotationDance = components['schemas']['BoyGroupRotationDance'];
export type GetBoyGroupRotationListRO = components['schemas']['GetBoyGroupRotationListRO'];
export type GetBoyGroupRotationListResponse = components['schemas']['GetBoyGroupRotationListResponse'];
export type GirlGroupRotationDance_Dance = components['schemas']['GirlGroupRotationDance_Dance'];
export type GirlGroupRotationDance_Artist = components['schemas']['GirlGroupRotationDance_Artist'];
export type GirlGroupRotationDance = components['schemas']['GirlGroupRotationDance'];
export type GetGirlGroupRotationListRO = components['schemas']['GetGirlGroupRotationListRO'];
export type GetGirlGroupRotationListResponse = components['schemas']['GetGirlGroupRotationListResponse'];
export type BoostDanceBody = components['schemas']['BoostDanceBody'];
export type GetDanceInfoInternalBody = components['schemas']['GetDanceInfoInternalBody'];

export type SimpleDance_Artist = components['schemas']['SimpleDance_Artist'];

export type GetDanceInfoInternalRO = components['schemas']['GetDanceInfoInternalRO'];
export type GetDanceInfoInternalResponse = components['schemas']['GetDanceInfoInternalResponse'];
export type UploadVideoBody = components['schemas']['UploadVideoBody'];
export type SignedUrl = components['schemas']['SignedUrl'];
export type UploadVideoRO = components['schemas']['UploadVideoRO'];
export type UploadVideoResponse = components['schemas']['UploadVideoResponse'];
export type UploadTournamentVideoBody = components['schemas']['UploadTournamentVideoBody'];
export type UploadTournamentVideoRO = components['schemas']['UploadTournamentVideoRO'];
export type UploadTournamentVideoResponse = components['schemas']['UploadTournamentVideoResponse'];
export type ModifyVideoBody = components['schemas']['ModifyVideoBody'];
export type ModifyVideoRO = components['schemas']['ModifyVideoRO'];
export type ModifyVideoResponse = components['schemas']['ModifyVideoResponse'];
// export type VideoInfo_Video = components['schemas']['VideoInfo_Video'];
// export type VideoInfo_Dance = components['schemas']['VideoInfo_Dance'];
// export type VideoInfo_Artist = components['schemas']['VideoInfo_Artist'];
// export type VideoInfo_Hashtag = components['schemas']['VideoInfo_Hashtag'];
// export type VideoInfo_Box = components['schemas']['VideoInfo_Box'];
// export type VideoInfo_Uploader = components['schemas']['VideoInfo_Uploader'];
// export type VideoInfo_Opponent = components['schemas']['VideoInfo_Opponent'];
// export type VideoInfo_VideoRPD = components['schemas']['VideoInfo_VideoRPD'];
// export type VideoInfo_Tournament = components['schemas']['VideoInfo_Tournament'];
// export type VideoInfo = components['schemas']['VideoInfo'];
export type VideoInfo_Video = any;
export type VideoInfo_Dance = any;
export type VideoInfo_Artist = any;
export type VideoInfo_Hashtag = any;
export type VideoInfo_Box = any;
export type VideoInfo_Uploader = any;
export type VideoInfo_Opponent = any;
export type VideoInfo_VideoRPD = any;
export type VideoInfo_Tournament = any;
export type VideoInfo = any;
export type GetVideoInfoRO = components['schemas']['GetVideoInfoRO'];
export type GetVideoInfoResponse = components['schemas']['GetVideoInfoResponse'];
export type GetUserVideoListRO = components['schemas']['GetUserVideoListRO'];
export type GetUserVideoListResponse = components['schemas']['GetUserVideoListResponse'];
export type BoostVideoBody = components['schemas']['BoostVideoBody'];
export type LikeVideoBody = components['schemas']['LikeVideoBody'];
export type GetHotDanceVideoListRO = components['schemas']['GetHotDanceVideoListRO'];
export type GetHotDanceVideoListResponse = components['schemas']['GetHotDanceVideoListResponse'];
export type GetHashtagVideoListRO = components['schemas']['GetHashtagVideoListRO'];
export type GetHashtagVideoListResponse = components['schemas']['GetHashtagVideoListResponse'];
export type GetArtistVideoListRO = components['schemas']['GetArtistVideoListRO'];
export type GetArtistVideoListResponse = components['schemas']['GetArtistVideoListResponse'];
export type GetFeedVideoListRO = components['schemas']['GetFeedVideoListRO'];
export type GetFeedVideoListResponse = components['schemas']['GetFeedVideoListResponse'];
export type GetFollowerVideoListRO = components['schemas']['GetFollowerVideoListRO'];
export type GetFollowerVideoListResponse = components['schemas']['GetFollowerVideoListResponse'];
export type ChangeVideoOptionBody = components['schemas']['ChangeVideoOptionBody'];
export type ShareVideoRO = components['schemas']['ShareVideoRO'];
export type ShareVideoResponse = components['schemas']['ShareVideoResponse'];
export type CheckVideoAliveRO = components['schemas']['CheckVideoAliveRO'];
export type CheckVideoAliveResponse = components['schemas']['CheckVideoAliveResponse'];
export type GetBestDancerVideoListRO = components['schemas']['GetBestDancerVideoListRO'];
export type GetBestDancerVideoListResponse = components['schemas']['GetBestDancerVideoListResponse'];
export type WatchVideoBody = components['schemas']['WatchVideoBody'];
export type GetTournamentBestVideoListRO = components['schemas']['GetTournamentBestVideoListRO'];
export type GetTournamentBestVideoListResponse = components['schemas']['GetTournamentBestVideoListResponse'];
export type GetTournamentChampionVideoListRO = components['schemas']['GetTournamentChampionVideoListRO'];
export type GetTournamentChampionVideoListResponse = components['schemas']['GetTournamentChampionVideoListResponse'];
export type CreateCustomBoxBody = components['schemas']['CreateCustomBoxBody'];
export type CommonBox_Box = components['schemas']['CommonBox_Box'];
export type CommonBoxDance_Dance = components['schemas']['CommonBoxDance_Dance'];
export type CommonBoxDance_Artist = components['schemas']['CommonBoxDance_Artist'];
export type CommonBoxDance = components['schemas']['CommonBoxDance'];
export type CommonBox = components['schemas']['CommonBox'];
export type GetBoxInfoRO = components['schemas']['GetBoxInfoRO'];
export type GetBoxInfoResponse = components['schemas']['GetBoxInfoResponse'];
export type EventBox_Box = components['schemas']['EventBox_Box'];
export type EventBoxDance_Dance = components['schemas']['EventBoxDance_Dance'];
export type EventBoxDance_Artist = components['schemas']['EventBoxDance_Artist'];
export type EventBoxDance = components['schemas']['EventBoxDance'];
export type EventBox = components['schemas']['EventBox'];
export type GetEventBoxRO = components['schemas']['GetEventBoxRO'];
export type GetEventBoxResponse = components['schemas']['GetEventBoxResponse'];
export type HotBox_Box = components['schemas']['HotBox_Box'];
export type HotBoxDance_Dance = components['schemas']['HotBoxDance_Dance'];
export type HotBoxDance_Artist = components['schemas']['HotBoxDance_Artist'];
export type HotBoxDance = components['schemas']['HotBoxDance'];
export type HotBox = components['schemas']['HotBox'];
export type GetHotBoxListRO = components['schemas']['GetHotBoxListRO'];
export type GetHotBoxListResponse = components['schemas']['GetHotBoxListResponse'];
export type CustomBox_Box = components['schemas']['CustomBox_Box'];
export type CustomBoxDance_Dance = components['schemas']['CustomBoxDance_Dance'];
export type CustomBoxDance_Artist = components['schemas']['CustomBoxDance_Artist'];
export type CustomBoxDance = components['schemas']['CustomBoxDance'];
export type CustomBox = components['schemas']['CustomBox'];
export type CustomBox_Extra = components['schemas']['CustomBox_Extra'];
export type GetCustomBoxListRO = components['schemas']['GetCustomBoxListRO'];
export type GetCustomBoxListResponse = components['schemas']['GetCustomBoxListResponse'];
export type CommentInfo_Comment = components['schemas']['CommentInfo_Comment'];
export type CommentInfo_User = components['schemas']['CommentInfo_User'];
export type CommentInfo = components['schemas']['CommentInfo'];
export type GetCommentInfoRO = components['schemas']['GetCommentInfoRO'];
export type GetCommentInfoResponse = components['schemas']['GetCommentInfoResponse'];
export type ReplyInfo_Comment = components['schemas']['ReplyInfo_Comment'];
export type ReplyInfo_User = components['schemas']['ReplyInfo_User'];
export type ReplyInfo = components['schemas']['ReplyInfo'];
export type GetReplyInfoRO = components['schemas']['GetReplyInfoRO'];
export type GetReplyInfoResponse = components['schemas']['GetReplyInfoResponse'];
export type CreateCommentBody = components['schemas']['CreateCommentBody'];
export type CommonComment_Comment = components['schemas']['CommonComment_Comment'];
export type CommonComment_User = components['schemas']['CommonComment_User'];
export type CommonComment = components['schemas']['CommonComment'];
export type CreateCommentRO = components['schemas']['CreateCommentRO'];
export type CreateCommentResponse = components['schemas']['CreateCommentResponse'];
export type CreateReplyBody = components['schemas']['CreateReplyBody'];
export type Reply_Comment = components['schemas']['Reply_Comment'];
export type Reply_User = components['schemas']['Reply_User'];
export type Reply = components['schemas']['Reply'];
export type CreateReplyRO = components['schemas']['CreateReplyRO'];
export type CreateReplyResponse = components['schemas']['CreateReplyResponse'];
export type ModifyCommentBody = components['schemas']['ModifyCommentBody'];
export type LikeCommentBody = components['schemas']['LikeCommentBody'];
export type GetCommentListRO = components['schemas']['GetCommentListRO'];
export type GetCommentListResponse = components['schemas']['GetCommentListResponse'];
export type GetReplyListRO = components['schemas']['GetReplyListRO'];
export type GetReplyListResponse = components['schemas']['GetReplyListResponse'];
export type GetUpperInfoRO = components['schemas']['GetUpperInfoRO'];
export type GetUpperInfoResponse = components['schemas']['GetUpperInfoResponse'];
export type MakeUserBody = components['schemas']['MakeUserBody'];
export type VerifyUserBody = components['schemas']['VerifyUserBody'];
export type VerifyTournamentUserBody = components['schemas']['VerifyTournamentUserBody'];
export type GetUserInfoInternalBody = components['schemas']['GetUserInfoInternalBody'];
export type SimpleUser_User = components['schemas']['SimpleUser_User'];
export type SimpleUser = components['schemas']['SimpleUser'];
export type GetUserInfoInternalRO = components['schemas']['GetUserInfoInternalRO'];
export type GetUserInfoInternalResponse = components['schemas']['GetUserInfoInternalResponse'];
export type UserInfo_User = components['schemas']['UserInfo_User'];
export type UserInfo = components['schemas']['UserInfo'];
export type GetUserInfoRO = components['schemas']['GetUserInfoRO'];
export type GetUserInfoResponse = components['schemas']['GetUserInfoResponse'];
export type UserMypage_User = components['schemas']['UserMypage_User'];
export type UserMypage = components['schemas']['UserMypage'];
export type GetUserMypageRO = components['schemas']['GetUserMypageRO'];
export type GetUserMypageResponse = components['schemas']['GetUserMypageResponse'];
export type ModifyUserStepinIdBody = components['schemas']['ModifyUserStepinIdBody'];
export type ModifyUserNicknameBody = components['schemas']['ModifyUserNicknameBody'];
export type ModifyUserDescriptionBody = components['schemas']['ModifyUserDescriptionBody'];
export type ModifyUserProfileImageRO = components['schemas']['ModifyUserProfileImageRO'];
export type ModifyUserProfileImageResponse = components['schemas']['ModifyUserProfileImageResponse'];
export type UserFollowing_User = components['schemas']['UserFollowing_User'];
export type UserFollowing = components['schemas']['UserFollowing'];
export type GetUserFollowingListRO = components['schemas']['GetUserFollowingListRO'];
export type GetUserFollowingListResponse = components['schemas']['GetUserFollowingListResponse'];
export type UserFollowed_User = components['schemas']['UserFollowed_User'];
export type UserFollowed = components['schemas']['UserFollowed'];
export type GetUserFollowedListRO = components['schemas']['GetUserFollowedListRO'];
export type GetUserFollowedListResponse = components['schemas']['GetUserFollowedListResponse'];
export type FollowUserBody = components['schemas']['FollowUserBody'];
export type UpdateFCMBody = components['schemas']['UpdateFCMBody'];
export type UpdateFCMOptionBody = components['schemas']['UpdateFCMOptionBody'];
export type VerifyStepinIdBody = components['schemas']['VerifyStepinIdBody'];
export type VerifyStepinIdRO = components['schemas']['VerifyStepinIdRO'];
export type VerifyStepinIdResponse = components['schemas']['VerifyStepinIdResponse'];
export type BlockUserBody = components['schemas']['BlockUserBody'];
export type CommonUser_User = components['schemas']['CommonUser_User'];
export type CommonUser = components['schemas']['CommonUser'];
export type GetBlockUserListRO = components['schemas']['GetBlockUserListRO'];
export type GetBlockUserListResponse = components['schemas']['GetBlockUserListResponse'];
export type ShareUserRO = components['schemas']['ShareUserRO'];
export type ShareUserResponse = components['schemas']['ShareUserResponse'];
export type ApplyBusinessAccountBody = components['schemas']['ApplyBusinessAccountBody'];
export type ApplyBusinessAccountRO = components['schemas']['ApplyBusinessAccountRO'];
export type ApplyBusinessAccountResponse = components['schemas']['ApplyBusinessAccountResponse'];
export type BusinessApplicationStatus_BusinessApplication =
	components['schemas']['BusinessApplicationStatus_BusinessApplication'];
export type BusinessApplicationStatus = components['schemas']['BusinessApplicationStatus'];
export type GetBusinessApplicationStatusRO = components['schemas']['GetBusinessApplicationStatusRO'];
export type GetBusinessApplicationStatusResponse = components['schemas']['GetBusinessApplicationStatusResponse'];
export type ModifyBusinessApplicationStatusBody = components['schemas']['ModifyBusinessApplicationStatusBody'];
export type ModifyBusinessNicknameBody = components['schemas']['ModifyBusinessNicknameBody'];
export type ModifyBusinessAccountIdBody = components['schemas']['ModifyBusinessAccountIdBody'];
export type ModifyBusinessDescriptionBody = components['schemas']['ModifyBusinessDescriptionBody'];
export type ModifyBusinessProfileImageRO = components['schemas']['ModifyBusinessProfileImageRO'];
export type ModifyBusinessProfileImageResponse = components['schemas']['ModifyBusinessProfileImageResponse'];
export type VerifyBusinessAccountIdBody = components['schemas']['VerifyBusinessAccountIdBody'];
export type VerifyBusinessAccountIdRO = components['schemas']['VerifyBusinessAccountIdRO'];
export type VerifyBusinessAccountIdResponse = components['schemas']['VerifyBusinessAccountIdResponse'];
export type GetUserCurrencyRO = components['schemas']['GetUserCurrencyRO'];
export type GetUserCurrencyResponse = components['schemas']['GetUserCurrencyResponse'];
export type ModifyUserCurrencyBody = components['schemas']['ModifyUserCurrencyBody'];
export type MakeBusinessAccountBody = components['schemas']['MakeBusinessAccountBody'];
export type CommercialTournamentPrize = components['schemas']['CommercialTournamentPrize'];
export type TournamentInfo_Tournament = components['schemas']['TournamentInfo_Tournament'];
export type TournamentInfo_Organizer = components['schemas']['TournamentInfo_Organizer'];

export type GetTournamentInfoRO = components['schemas']['GetTournamentInfoRO'];
export type GetTournamentInfoResponse = components['schemas']['GetTournamentInfoResponse'];
export type CreateCommunityTournamentBody = components['schemas']['CreateCommunityTournamentBody'];
export type CreateCommunityTournamentResponse = components['schemas']['CreateCommunityTournamentResponse'];
export type CreateCommercialTournamentBody = components['schemas']['CreateCommercialTournamentBody'];
export type CreateCommercialTournamentRO = components['schemas']['CreateCommercialTournamentRO'];
export type CreateCommercialTournamentResponse = components['schemas']['CreateCommercialTournamentResponse'];
export type ModifyTournamentTitleBody = components['schemas']['ModifyTournamentTitleBody'];
export type ModifyTournamentPosterBody = components['schemas']['ModifyTournamentPosterBody'];
export type ModifyTournamentPosterRO = components['schemas']['ModifyTournamentPosterRO'];
export type ModifyTournamentPosterRespone = components['schemas']['ModifyTournamentPosterRespone'];
export type ModifyTournamentBannerBody = components['schemas']['ModifyTournamentBannerBody'];
export type ModifyTournamentBannerRO = components['schemas']['ModifyTournamentBannerRO'];
export type ModifyTournamentBannerResponse = components['schemas']['ModifyTournamentBannerResponse'];
export type ModifyTournamentPrizeBody = components['schemas']['ModifyTournamentPrizeBody'];
export type ModifyTournamentScheduleBody = components['schemas']['ModifyTournamentScheduleBody'];
export type ModifyTournamentNoticeBody = components['schemas']['ModifyTournamentNoticeBody'];
export type ModifyTournamentDanceBody = components['schemas']['ModifyTournamentDanceBody'];
export type ModifyTournamentInfoBody = components['schemas']['ModifyTournamentInfoBody'];
export type SetTournamentOpenBody = components['schemas']['SetTournamentOpenBody'];
export type ShareTournamentRO = components['schemas']['ShareTournamentRO'];
export type ShareTournamentResponse = components['schemas']['ShareTournamentResponse'];
export type GetMainTournamentListRO = components['schemas']['GetMainTournamentListRO'];
export type GetMainTournamentListResponse = components['schemas']['GetMainTournamentListResponse'];
export type GetUpcommingTournamentListRO = components['schemas']['GetUpcommingTournamentListRO'];
export type GetUpcommingTournamentListResponse = components['schemas']['GetUpcommingTournamentListResponse'];
export type BestTournamentInfo = components['schemas']['BestTournamentInfo'];
export type GetBestTournamentListRO = components['schemas']['GetBestTournamentListRO'];
export type GetBestTournamentListResponse = components['schemas']['GetBestTournamentListResponse'];
export type RoundInfo_Round = components['schemas']['RoundInfo_Round'];
export type LiveTournamentInfo = components['schemas']['LiveTournamentInfo'];
export type GetLiveTournamentListRO = components['schemas']['GetLiveTournamentListRO'];
export type GetLiveTournamentListResponse = components['schemas']['GetLiveTournamentListResponse'];
export type GetSpecificStatusTournamentListRO = components['schemas']['GetSpecificStatusTournamentListRO'];
export type GetSpecificStatusTournamentListResponse = components['schemas']['GetSpecificStatusTournamentListResponse'];
export type GetParticipatingTournamentListRO = components['schemas']['GetParticipatingTournamentListRO'];
export type GetParticipatingTournamentListResponse = components['schemas']['GetParticipatingTournamentListResponse'];
export type GetCreatedTournamentListRO = components['schemas']['GetCreatedTournamentListRO'];
export type GetCreatedTournamentListResponse = components['schemas']['GetCreatedTournamentListResponse'];
export type JoinTournamentBody = components['schemas']['JoinTournamentBody'];
export type ApplyTournamentBody = components['schemas']['ApplyTournamentBody'];
export type TournamentApplicantInfo_TournamentApplicant =
	components['schemas']['TournamentApplicantInfo_TournamentApplicant'];
export type TournamentApplicantInfo = components['schemas']['TournamentApplicantInfo'];
export type GetTournamentApplicantListRO = components['schemas']['GetTournamentApplicantListRO'];
export type GetTournamentApplicantListResponse = components['schemas']['GetTournamentApplicantListResponse'];
export type ModifyTournamentApplicantStatusBody = components['schemas']['ModifyTournamentApplicantStatusBody'];
export type TournamentParticipantInfo_TournamentParticipant =
	components['schemas']['TournamentParticipantInfo_TournamentParticipant'];
export type TournamentParticipantInfo = components['schemas']['TournamentParticipantInfo'];
export type GetTournamentParticipantListRO = components['schemas']['GetTournamentParticipantListRO'];
export type GetTournamentParticipantListResponse = components['schemas']['GetTournamentParticipantListResponse'];
export type RoundInfo = components['schemas']['RoundInfoDto'];
export type RoundInfoDto = components['schemas']['RoundInfoDto'];
export type GetTournamentRoundListRO = components['schemas']['GetTournamentRoundListRO'];
export type GetTournamentRoundListResponse = components['schemas']['GetTournamentRoundListResponse'];
export type TournamentDance_Dance = components['schemas']['TournamentDance_Dance'];
export type TournamentDance_Artist = components['schemas']['TournamentDance_Artist'];
export type TournamentDance = components['schemas']['TournamentDance'];
export type TournamentDanceInfoDto = components['schemas']['TournamentDanceInfoDto'];

export type GetTournamentDanceListRO = components['schemas']['GetTournamentDanceListRO'];
export type GetTournamentDanceListResponse = components['schemas']['GetTournamentDanceListResponse'];
export type InitTournamentBody = components['schemas']['InitTournamentBody'];
export type TournamentInboxData = components['schemas']['TournamentInboxData'];
export type TournamentInbox_Inbox = components['schemas']['TournamentInbox_Inbox'];
export type TournamentInbox = components['schemas']['TournamentInbox'];
export type GetTournamentActivityInboxListRO = components['schemas']['GetTournamentActivityInboxListRO'];
export type GetTournamentActivityInboxListResponse = components['schemas']['GetTournamentActivityInboxListResponse'];
export type GetTournamentGameInboxListRO = components['schemas']['GetTournamentGameInboxListRO'];
export type GetTournamentGameInboxListResponse = components['schemas']['GetTournamentGameInboxListResponse'];
export type InviteTournamentBody = components['schemas']['InviteTournamentBody'];
export type ModifyTournamentInviteBody = components['schemas']['ModifyTournamentInviteBody'];
export type ParentConsentBody = components['schemas']['ParentConsentBody'];
export type ParentConsentRO = components['schemas']['ParentConsentRO'];
export type ParentConsentResponse = components['schemas']['ParentConsentResponse'];
export type CheckParentConsentRO = components['schemas']['CheckParentConsentRO'];
export type CheckParentConsentReponse = components['schemas']['CheckParentConsentReponse'];
// export type ReportUserBody = components['schemas']['ReportUserBody'];
// export type ReportVideoBody = components['schemas']['ReportVideoBody'];
// export type ReportCommentBody = components['schemas']['ReportCommentBody'];
// export type ReportTournamentBody = components['schemas']['ReportTournamentBody'];
export type CommonTrend_Trend = components['schemas']['CommonTrend_Trend'];
export type CommonTrend = components['schemas']['CommonTrend'];
export type GetTrendRO = components['schemas']['GetTrendRO'];
export type GetTrendResponse = components['schemas']['GetTrendResponse'];
